import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
    padding: 5,
    margin: 5,
    flexDirection: 'row',
    borderWidth: 1,
  },
});
